<script setup lang="ts" name="">
import { BASE_TAG_CONTRAST } from '~/constants';

import BaseAlert from '~/components/BaseAlert.vue';
import BaseTag from '~/components/BaseTag.vue';

defineProps<{
  loading?: boolean;
  bookingNo?: string;
  tradeLane?: string;
  completed?: boolean;
}>();
</script>

<template>
  <div class="mr-4 flex items-center justify-between">
    <div class="flex-center space-x-4">
      <p
        v-if="loading"
        class="animate-pulse bg-charcoal-2 text-headline text-charcoal-2"
        data-test="profile-title"
      >
        Booking No
      </p>

      <p
        v-else
        class="text-headline text-secondary-9"
        data-test="profile-title"
      >
        {{ bookingNo }}
      </p>

      <BaseTag
        v-if="tradeLane"
        :name="tradeLane"
        :variant="BASE_TAG_CONTRAST.OCEAN_3"
      />
    </div>
  </div>

  <div class="flex items-end justify-between">
    <BaseAlert
      v-if="completed"
      icon="ic:baseline-check-circle"
      type="success"
      class="mt-4 max-w-max"
    >
      <p class="leading-none">Shipment has been delivered.</p>
    </BaseAlert>
  </div>
</template>
